var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2694 18.5465C22.7646 17.0418 20.9735 15.9278 19.0193 15.2535C21.1123 13.812 22.4874 11.3994 22.4874 8.67146C22.4874 4.2673 18.9043 0.684204 14.5001 0.684204C10.096 0.684204 6.51286 4.2673 6.51286 8.67146C6.51286 11.3994 7.88791 13.812 9.98095 15.2535C8.02677 15.9278 6.23568 17.0418 4.7309 18.5465C2.35836 20.9191 0.954952 24.0025 0.719669 27.3165C0.680557 27.8674 1.13204 28.3158 1.68433 28.3158H1.84304C2.39533 28.3158 2.83855 27.8665 2.8855 27.3162C3.39412 21.3546 8.40903 16.6587 14.5001 16.6587C20.5912 16.6587 25.6061 21.3546 26.1147 27.3162C26.1617 27.8665 26.6049 28.3158 27.1572 28.3158H27.3159C27.8682 28.3158 28.3197 27.8674 28.2806 27.3165C28.0453 24.0025 26.6419 20.9191 24.2694 18.5465ZM14.5001 14.5C11.2863 14.5 8.67158 11.8854 8.67158 8.67146C8.67158 5.45756 11.2863 2.84292 14.5001 2.84292C17.714 2.84292 20.3287 5.45756 20.3287 8.67146C20.3287 11.8854 17.714 14.5 14.5001 14.5Z",
    fill: "#2B2526",
    stroke: "#2B2526",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDashboard);
export default __webpack_public_path__ + "static/media/userDashboard.445c6bf8d219e76f70160bdfc6bf3999.svg";
export { ForwardRef as ReactComponent };